import React, { Component } from 'react';
import { BarChart , Bar, XAxis, YAxis, CartesianGrid, Tooltip, Cell } from 'recharts';
import config from '../config'

const { MORNING_START, MORNING_END, NOON, DAY_EXPECT, INTENSE_COLORS, ORDINARY_COLORS, MORNING_EXPECT } = config.rules;

class CustomTooltip extends Component {

  render() {
    const { coordinate } = this.props;
    const incomeStyle = {
      left: coordinate.x - 75 ,
    }
    
    const { active } = this.props;
    const { payload } = this.props;

    if ( active && payload[0].payload.sumHs > 0) {
      return (
        <div className="custom-tooltip" style={incomeStyle} >
          <p className="label"> { payload[0].payload.tooltip } </p>
          <br />
          <p className="label"> { ' مدت:  ' + payload[0].payload.duration } </p>
        </div>
      );
    }

    return '';
  }
}

class Barchart extends Component {

  componentWillMount() {
    this.props.calculateFunc();
  }

  componentWillReceiveProps(nextProps,nextState){
    if( JSON.stringify(nextProps.records) !== JSON.stringify(this.props.records)  ){
        this.props.calculateFunc();
    }
  }

  render() {
    let barchartContainer = { 
      width:window.innerWidth * 0.90 * 0.9 , 
      height:window.innerHeight * 0.5 
    };
    
    let { barchartList } = this.props;
    let dataList = [];
    for ( let bar of barchartList){
      dataList.push({
        name: bar.title,
        'مدت': bar.sumDataHs,
        sumHs: bar.sumDataHs,
        tooltip: bar.tooltip,
        duration: bar.sumData.split(':')[0]+':'+bar.sumData.split(':')[1],
        recordsList: [...bar.dataList]
      })

    }

    if(this.props.records.length > 0) {
      return (
        <div id="barchart-container" className="container-fluid barchart-container" >
          <div className="row total-container">
            <h4>
              <span className="small total-span" >
                مجموع  
              </span>
              <span>
                 { this.props.total_sum }
              </span>
            </h4>
          </div>
          <div className="row barchart">
              <BarChart maxBarSize={50} width={barchartContainer.width} height={barchartContainer.height} data={dataList}>
                <CartesianGrid vertical={false} strokeDasharray="3 3"/>
                <XAxis dataKey="name"  />
                <YAxis />
                <Tooltip cursor={false} isAnimationActive={false} content={ <CustomTooltip /> }/>
                <Bar isAnimationActive={false} dataKey="مدت">
                  {dataList.map((entry, index) => {
                    let morning = 0;
                    let check1 = false;
                    if (entry.recordsList.length > 0) {
                      let sumDuration = 0;
                      for (let i = 0; i < entry.recordsList.length; i++) {
                        let start_list = entry.recordsList[i].start.split("T")[1].split(":");
                        let start_minutes = parseInt(start_list[0])*60 + parseInt(start_list[1]);
                        if (start_minutes > (MORNING_START * 60 - 1) && start_minutes < (MORNING_END * 60 + 1)) {
                          check1 = true;
                        }
                        if (start_minutes > (MORNING_START* 60 - 1) && start_minutes < (NOON*60 + 1)) {
                          let end_list = entry.recordsList[i].end.split("T")[1].split(":");
                          let end_minutes = parseInt(end_list[0])*60 + parseInt(end_list[1]);

                          if (end_minutes < (NOON * 60 + 1)) {
                            sumDuration += entry.recordsList[i].duration;
                          } else {
                            let delta = entry.recordsList[i].duration - (end_minutes * 60 - NOON * 3600) + 1;
                            sumDuration += delta;
                          }
                            
                        }
                      }
                      if (check1 && sumDuration > MORNING_EXPECT - 1) morning = 1
                    }
                    return <Cell fill={entry.sumHs > DAY_EXPECT ? INTENSE_COLORS[morning] : ORDINARY_COLORS[morning] }/>
                  })}
                </Bar>
              </BarChart>  
          </div>
        </div>
      )
    }
    else{
      return(
        <div className="container-fluid barchart-container" >
          <div className="row total-container">
            <div className="col-sm-3 col-sm-push-5">
              <h4>
                رکوردی یافت نشد!
              </h4>
            </div>
          </div>
        </div>
      )
    }

    
  } 
}

export default Barchart